import React from 'react';
import PropTypes from 'prop-types'

export const ButtonLink = ({ text, href = '#', onClick }) => {
	return (
		<a href={href} onClick={onClick}>{text}</a>
	)
}

ButtonLink.propTypes = {
	text: PropTypes.string,
	href: PropTypes.string,
	onClick: PropTypes.func,
}


// WEBPACK FOOTER //
// ./buttons/components/buttonLink/ButtonLink.js